const BannerService = () => {
  return <div id="service" className="banner-service-container">Nuestros servicios</div>;
};

export default BannerService;
